import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_URL, ADMIN_API_PREFIX } from '@CONSTANTS/API.constant';
import userRepository from '@REPOSITORIES/local-repository/user-repository';
import { DocumentSettings } from '../api/app-settings.api';

type UpdateDocumentSettingsParams = Partial<DocumentSettings> & {
    document_header_image?: File;
};

export const documentSettingsAdminApi = createApi({
    reducerPath: 'document-settings-admin-api',
    baseQuery: fetchBaseQuery({
        baseUrl: BASE_URL + ADMIN_API_PREFIX,
        prepareHeaders: (headers) => {
            const token = userRepository.getData();

            if (token) {
                headers.set('Authorization', `Bearer ${token}`);
            }

            return headers;
        },
    }),
    tagTypes: ['DocumentSettings'],
    endpoints: (builder) => ({
        updateDocumentSettings: builder.mutation<DocumentSettings, UpdateDocumentSettingsParams>({
            query: (params) => {
                const formData = new FormData();

                Object.entries(params).forEach(([key, value]) => {
                    if (value !== undefined && value !== null) {
                        // Check if value is a File object by checking for File-specific properties
                        if (typeof value === 'object' && 'name' in value && 'size' in value && 'type' in value) {
                            formData.append(key, value as File);
                        } else {
                            formData.append(key, value.toString());
                        }
                    }
                });

                return {
                    url: '/document-settings/',
                    method: 'POST',
                    body: formData,
                };
            },
            invalidatesTags: ['DocumentSettings'],
        }),
    }),
});

export const {
    useUpdateDocumentSettingsMutation,
} = documentSettingsAdminApi; 